export function isTour(ooi: Travelguide.OOI): ooi is Travelguide.Tour {
  return (
    ooi && "rating" in ooi && "difficulty" in ooi.rating && "distance" in ooi
  );
}

export function isAccomodation(
  ooi: Travelguide.OOI
): ooi is Travelguide.Accomodation {
  return ooi.category.activity?.slug === "unterkunft";
}

export function isImageSection(
  section: Travelguide.POISection | Travelguide.TourSection
): section is Travelguide.POISection.Image {
  return section.type === "image";
}
